import { ProjectHeaderButton } from "@/containers/Project/components/ProjectHeader/styled";
import { routes } from "@/helpers";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row } from "antd";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

interface IProps {
  projectId: string | undefined;
}

export const RisksAndIssuesButton = ({ projectId }: IProps) => {
  const intl = useIntl();

  return (
    <Link to={routes.projects.risksAndIssues(projectId ?? "")}>
      <ProjectHeaderButton type="text">
        <Row justify="center">
          <FontAwesomeIcon size="xl" icon={faTriangleExclamation as IconProp} />
        </Row>
        <Row justify="center">
          {intl.formatMessage({ id: "project.risksAndIssuesTitle" })}
        </Row>
      </ProjectHeaderButton>
    </Link>
  );
};
